import { mutations as TYPES } from './types';
import { State } from './state';

const mutations = {
  /**
   * Reset
   * @param state ..
   * @param state.show ..
   */
  [TYPES.RESET](_state: State) {
    _state = new State();
  },
};

export default mutations;
